/* ═══════════════════════════════════════════════════════════════
   UNTIED SOCIETY — THEME JS
   Vanilla only. No dependencies. Idempotent — safe to re-run on
   Shopify section render events in the theme editor.
   ═══════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ── Wishlist ────────────────────────────────────────────────
     localStorage only. No account, no network. Deliberate: it
     works for a guest on first visit, which is who we have.     */
  var KEY = 'untied:wishlist';

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; }
    catch (e) { return []; }
  }
  function write(ids) {
    try { localStorage.setItem(KEY, JSON.stringify(ids)); } catch (e) {}
    document.dispatchEvent(new CustomEvent('untied:wishlist', { detail: { ids: ids } }));
  }
  function has(id) { return read().indexOf(id) !== -1; }

  function toggle(id) {
    var ids = read();
    var i = ids.indexOf(id);
    if (i === -1) { ids.push(id); } else { ids.splice(i, 1); }
    write(ids);
    return ids.indexOf(id) !== -1;
  }

  function paint(btn) {
    var id = btn.getAttribute('data-wish');
    var on = has(id);
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    var title = btn.getAttribute('data-title') || 'this piece';
    btn.setAttribute('aria-label', (on ? 'Remove ' : 'Save ') + title +
      (on ? ' from your saved list' : ' to your saved list'));
  }

  function initWishlist(root) {
    (root || document).querySelectorAll('[data-wish]').forEach(function (btn) {
      if (btn.dataset.usBound === '1') return;
      btn.dataset.usBound = '1';
      paint(btn);
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        toggle(btn.getAttribute('data-wish'));
        paint(btn);
      });
    });
    updateCounts();
  }

  function updateCounts() {
    var n = read().length;
    document.querySelectorAll('[data-wish-count]').forEach(function (el) {
      el.textContent = n > 0 ? String(n) : '';
      el.hidden = n === 0;
    });
  }
  document.addEventListener('untied:wishlist', function () {
    document.querySelectorAll('[data-wish]').forEach(paint);
    updateCounts();
  });

  /* ── Reveal on scroll ────────────────────────────────────────
     One authored moment per section, not a cascade of effects.  */
  function initReveal(root) {
    var els = (root || document).querySelectorAll('.us-reveal');
    if (!els.length) return;

    if (REDUCED || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    els.forEach(function (el) {
      if (el.dataset.usSeen === '1') { el.classList.add('is-in'); return; }
      el.dataset.usSeen = '1';
      io.observe(el);
    });
  }

  /* ── Drop countdown ──────────────────────────────────────────
     Driven by a real ISO datetime from section settings. When it
     passes, the block removes itself rather than showing zeros —
     an expired timer is worse than no timer.                    */
  function initCountdown(root) {
    (root || document).querySelectorAll('[data-countdown]').forEach(function (el) {
      if (el.dataset.usBound === '1') return;
      el.dataset.usBound = '1';

      var target = Date.parse(el.getAttribute('data-countdown'));
      if (isNaN(target)) { el.hidden = true; return; }

      var out = {
        days: el.querySelector('[data-cd="days"]'),
        hours: el.querySelector('[data-cd="hours"]'),
        minutes: el.querySelector('[data-cd="minutes"]')
      };

      function tick() {
        var diff = target - Date.now();
        if (diff <= 0) {
          el.hidden = true;
          clearInterval(timer);
          return;
        }
        var mins = Math.floor(diff / 60000);
        var d = Math.floor(mins / 1440);
        var h = Math.floor((mins % 1440) / 60);
        var m = mins % 60;
        if (out.days) out.days.textContent = String(d);
        if (out.hours) out.hours.textContent = String(h).padStart(2, '0');
        if (out.minutes) out.minutes.textContent = String(m).padStart(2, '0');
      }
      tick();
      var timer = setInterval(tick, 30000);
    });
  }

  /* ── Newsletter ──────────────────────────────────────────────
     Progressive enhancement over Shopify's native customer form.
     Validates before submit so the error is inline, not a reload. */
  function initNewsletter(root) {
    (root || document).querySelectorAll('[data-newsletter]').forEach(function (form) {
      if (form.dataset.usBound === '1') return;
      form.dataset.usBound = '1';

      var input = form.querySelector('input[type="email"]');
      var msg = form.querySelector('[data-newsletter-msg]');
      if (!input) return;

      form.addEventListener('submit', function (e) {
        var value = input.value.trim();
        if (value && input.checkValidity()) {
          if (msg) { msg.textContent = ''; msg.className = 'us-form__msg'; }
          return; // let Shopify handle it
        }
        e.preventDefault();
        input.setAttribute('aria-invalid', 'true');
        if (msg) {
          msg.className = 'us-form__msg us-form__msg--err';
          msg.textContent = value
            ? 'Add everything after the @ — we send order updates here.'
            : 'Enter your email address to join the list.';
        }
        input.focus();
      });

      input.addEventListener('input', function () {
        input.removeAttribute('aria-invalid');
        if (msg && msg.classList.contains('us-form__msg--err')) {
          msg.textContent = '';
          msg.className = 'us-form__msg';
        }
      });
    });
  }


  /* ── Gallery ──────────────────────────────────────────────── */
  function initGallery(root) {
    (root || document).querySelectorAll('[data-us-product] .us-gal').forEach(function (gal) {
      if (gal.dataset.usBound === '1') return;
      gal.dataset.usBound = '1';
      var slides = gal.querySelectorAll('[data-gal-slide]');
      var thumbs = gal.querySelectorAll('[data-gal-thumb]');
      function show(i) {
        slides.forEach(function (s) { s.classList.toggle('is-active', s.getAttribute('data-gal-slide') == i); });
        thumbs.forEach(function (t) {
          var on = t.getAttribute('data-gal-thumb') == i;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
      }
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () { show(t.getAttribute('data-gal-thumb')); });
      });
    });
  }

  /* ── Variant picker ───────────────────────────────────────── */
  function initProduct(root) {
    (root || document).querySelectorAll('[data-us-product]').forEach(function (product) {
      if (product.dataset.usBound === '1') return;
      product.dataset.usBound = '1';

      var jsonEl = product.querySelector('[data-variant-json]');
      var form = product.querySelector('[data-us-form]');
      if (!jsonEl || !form) return;

      var variants;
      try { variants = JSON.parse(jsonEl.textContent); } catch (e) { return; }

      var idField = form.querySelector('[data-variant-id]');
      var addBtn = form.querySelector('[data-add-btn]');
      var addText = form.querySelector('[data-add-text]');
      var priceBlock = product.querySelector('[data-price-block]');
      var money = (window.Shopify && Shopify.money_format) || '${{amount}}';

      function selectedOptions() {
        var opts = [];
        form.querySelectorAll('.us-opt').forEach(function (fs) {
          var checked = fs.querySelector('input:checked');
          opts.push(checked ? checked.value : null);
        });
        return opts;
      }

      function match(opts) {
        return variants.find(function (v) {
          return v.options.every(function (o, i) { return o === opts[i]; });
        });
      }

      function formatMoney(cents) {
        var amount = (cents / 100).toFixed(2);
        return money.replace(/\{\{\s*amount\s*\}\}/, amount);
      }

      function render(v) {
        if (!v) {
          addBtn.setAttribute('disabled', '');
          if (addText) addText.textContent = 'Unavailable';
          return;
        }
        idField.value = v.id;
        // reflect in URL so refresh/share keeps the variant
        try {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', u);
        } catch (e) {}

        if (priceBlock) {
          var sale = v.compare_at_price && v.compare_at_price > v.price;
          priceBlock.innerHTML =
            '<span class="us-price' + (sale ? ' us-price--sale' : '') + '">' +
            (sale ? '<s class="us-price__was">' + formatMoney(v.compare_at_price) + '</s>' : '') +
            '<span class="us-price__now">' + formatMoney(v.price) + '</span>' +
            (v.available ? '' : '<span class="us-price__so">Sold out</span>') +
            '</span>';
        }
        if (v.available) {
          addBtn.removeAttribute('disabled');
          if (addText) addText.textContent = 'Add to bag';
        } else {
          addBtn.setAttribute('disabled', '');
          if (addText) addText.textContent = 'Sold out';
        }
      }

      form.querySelectorAll('.us-opt input').forEach(function (input) {
        input.addEventListener('change', function () { render(match(selectedOptions())); });
      });

      // AJAX add to bag
      form.addEventListener('submit', function (e) {
        if (!window.fetch) return; // let it POST normally
        e.preventDefault();
        if (addBtn.hasAttribute('disabled')) return;
        var busyLabel = addText ? addText.textContent : '';
        addBtn.setAttribute('aria-busy', 'true');
        if (addText) addText.textContent = 'Adding…';

        var data = new FormData(form);
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: data
        })
        .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); })
        .then(function (res) {
          addBtn.removeAttribute('aria-busy');
          if (addText) addText.textContent = busyLabel;
          if (!res.ok) {
            toast('Could not add', res.body.description || 'Please choose an available option.', null);
            return;
          }
          bumpCart();
          toast('Added to your bag', res.body.title || '', '/cart');
        })
        .catch(function () {
          addBtn.removeAttribute('aria-busy');
          if (addText) addText.textContent = busyLabel;
          form.submit(); // hard fallback
        });
      });

      // size guide modal
      var modal = product.querySelector('[data-size-modal]');
      if (modal) {
        product.querySelectorAll('[data-size-open]').forEach(function (b) {
          b.addEventListener('click', function () { openModal(modal); });
        });
        modal.querySelectorAll('[data-size-close]').forEach(function (b) {
          b.addEventListener('click', function () { closeModal(modal); });
        });
        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape' && !modal.hidden) closeModal(modal);
        });
      }

      // init with server-selected variant
      render(match(selectedOptions()));
    });
  }

  function openModal(m) {
    m.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    var focusable = m.querySelector('[data-size-close]');
    if (focusable) focusable.focus();
  }
  function closeModal(m) {
    m.hidden = true;
    document.documentElement.style.overflow = '';
  }

  /* ── Cart badge bump ──────────────────────────────────────── */
  function bumpCart() {
    if (!window.fetch) return;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.us-hd__badge').forEach(function (el) {
          // only the cart badge, not the wishlist badge (which has data-wish-count)
          if (el.hasAttribute('data-wish-count')) return;
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
      })
      .catch(function () {});
  }

  /* ── Toast ────────────────────────────────────────────────── */
  var toastEl, toastTimer;
  function toast(title, desc, href) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'us-scope us-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    var actions = href
      ? '<div class="us-toast__row"><a class="us-btn us-btn--primary" href="' + href + '">View bag</a>' +
        '<button type="button" class="us-btn us-btn--ghost" data-toast-close>Keep shopping</button></div>'
      : '';
    toastEl.innerHTML =
      '<p class="us-toast__t">' + title + '</p>' +
      (desc ? '<p class="us-toast__d">' + desc + '</p>' : '') + actions;
    var close = toastEl.querySelector('[data-toast-close]');
    if (close) close.addEventListener('click', hideToast);
    requestAnimationFrame(function () { toastEl.classList.add('is-in'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(hideToast, 6000);
  }
  function hideToast() { if (toastEl) toastEl.classList.remove('is-in'); }

  /* ── Boot ────────────────────────────────────────────────────*/
  function initHeroSlideshow(root) {
    var hero = root.querySelector('[data-hero-slideshow]');
    if (!hero) return;
    var slides = hero.querySelectorAll('[data-slide-index]');
    var dots = hero.querySelectorAll('[data-slide-dot]');
    if (slides.length < 2) return;
    var interval = (parseInt(hero.getAttribute('data-interval'), 10) || 5) * 1000;
    var current = 0;
    var timer;

    function go(idx) {
      slides[current].classList.remove('is-active');
      if (dots[current]) dots[current].classList.remove('is-active');
      current = idx % slides.length;
      slides[current].classList.add('is-active');
      if (dots[current]) dots[current].classList.add('is-active');
    }
    function advance() { go(current + 1); }
    function start() { timer = setInterval(advance, interval); }
    function stop() { clearInterval(timer); }

    dots.forEach(function(dot) {
      dot.addEventListener('click', function() {
        stop();
        go(parseInt(dot.getAttribute('data-slide-dot'), 10));
        start();
      });
    });

    start();
  }

  function initCarouselHoverScroll(root) {
    (root || document).querySelectorAll('.us-grid--carousel').forEach(function (carousel) {
      if (carousel.dataset.usHover === '1') return;
      carousel.dataset.usHover = '1';
      var raf = null;
      var speed = 0;
      var ZONE = 120;
      var MAX_SPEED = 8;

      function tick() {
        if (speed === 0) { raf = null; return; }
        carousel.scrollLeft += speed;
        raf = requestAnimationFrame(tick);
      }

      carousel.addEventListener('mousemove', function (e) {
        var rect = carousel.getBoundingClientRect();
        var x = e.clientX - rect.left;
        var w = rect.width;
        if (x > w - ZONE) {
          speed = MAX_SPEED * Math.min((x - (w - ZONE)) / ZONE, 1);
        } else if (x < ZONE) {
          speed = -MAX_SPEED * Math.min((ZONE - x) / ZONE, 1);
        } else {
          speed = 0;
        }
        if (speed !== 0 && !raf) raf = requestAnimationFrame(tick);
      });
      carousel.addEventListener('mouseleave', function () {
        speed = 0;
      });
    });
  }

  function boot(root) {
    initWishlist(root);
    initReveal(root);
    initCountdown(root);
    initNewsletter(root);
    initGallery(root);
    initProduct(root);
    initHeroSlideshow(root);
    initCarouselHoverScroll(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  // Theme editor: re-bind only the section that changed.
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:section:select', function (e) { boot(e.target); });
})();
